import { Component } from '@angular/core';
import { AlertController, LoadingController, MenuController, ModalController, ToastController, PopoverController, NavController, Platform } from '@ionic/angular';
import { ServiceHelper } from './core/helper/services.helper';
import { ErrorLoggingService } from './data/service/error-logging.service';
import { EntityFactory } from './core/data/schema/entity-factory';
import { Entity } from './core/data/schema/entity';
import { HttpService } from './core/data/service/http.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { register } from 'swiper/element/bundle';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  warningVisible = false;

  constructor(
    errSvc: ErrorLoggingService,
    httpService: HttpService,
    alertCtrl: AlertController,
    loadCtrl: LoadingController,
    navCtrl: NavController,
    platform: Platform,
    toastCtrl: ToastController,
    popoverCtrl: PopoverController,
    title: Title,
    menuCtrl: MenuController,
    sanitizer: DomSanitizer,
    modalCtrl: ModalController
  ) {

    // just calling this init() to make sure error logging service is loaded asap to handle chunk load errors
    errSvc.init();

    Entity.factory = new EntityFactory(httpService);

    ServiceHelper.popoverCtrl = popoverCtrl;
    ServiceHelper.loadCtrl = loadCtrl;
    ServiceHelper.navCtrl = navCtrl;
    ServiceHelper.platform = platform;
    ServiceHelper.alertCtrl = alertCtrl;
    ServiceHelper.toastCtrl = toastCtrl;
    ServiceHelper.httpSvc = httpService;
    ServiceHelper.title = title;
    ServiceHelper.menuCtrl = menuCtrl;
    ServiceHelper.sanitizer = sanitizer;
    ServiceHelper.modalCtrl = modalCtrl;
    ServiceHelper.appComponent = this;
  }

  closeWarning() {
    this.warningVisible = false;
  }
}
